import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";
import { TWButton } from "../../../components/ui";

const COPIED_MS = 2000;

// Copy button: label flips to "Copied" for 2 s. Guarded for browsers (and
// jsdom) without the async clipboard. Shared by the token and code modals.
const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    const clipboard = navigator.clipboard;
    if (!clipboard?.writeText) return;
    try {
      await clipboard.writeText(text);
    } catch (err) {
      return;
    }
    message.success("Copied to clipboard");
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), COPIED_MS);
  };

  return <TWButton onClick={copy}>{copied ? "Copied" : "Copy"}</TWButton>;
};

export default CopyButton;
